import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as types from './mutation-types'
import _ from 'lodash'
import configureModerator from './store-moderator'
import router from '../router'
import 'es6-promise/auto'

Vue.use(Vuex)

const state = {
  language: {
    select: ['RO', 'EN']
  },
  isContestUploadSuccess: false,
  isModal: false,
  content: {
    RO: {
      menu: {
        // about: 'despre',
        concurs: 'concursuri',
        invitati: 'invitați',
        program: 'program',
        streetart: 'streetart',
        // voluntar: 'voluntari',
        parteneri: 'parteneri',
        echipa: 'echipă',
        press: 'press',
        archive: 'arhivă',
        contact: 'contact'
      },
      home: {
        title: 'Blecher Fest 2018',
        subTitle: '25 - 27 Mai / Roman - ediția a II-a',
        description: 'Blecher Fest - festival de literatura si cultura, ce il celebreaza pe scriitorul Max Blecher.'
      },
      contest: {
        title: 'Concursuri:',
        description: `Anul acesta, Blecher Fest propune trei concursuri pentru următoarele secțiuni:
                    proză, poezie și artă fotografică. <br><br> Tema generală este:`,
        juriu: {
          description: `Juriul este format din:`,
          sections: [
            {
              name: 'proză:',
              juriu: [
                {
                  name: 'Alain Gavriluțiu',
                  pic: 'http://www.hergbenet.ro/wp-content/uploads/2014/04/alain-gavrilutiu-2.jpg',
                  link: 'http://www.humanitas.ro/alain-gavrilutiu'
                },
                {
                  name: 'Cosmin Perța',
                  pic: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Cosmin-Perta.jpg',
                  link: 'https://ro.wikipedia.org/wiki/Cosmin_Per%C8%9Ba'
                },
                {
                  name: 'Sorin Mihai Grad',
                  pic: 'http://www.hergbenet.ro/wp-content/uploads/2013/12/Sorin_Mihai_Grad.jpg',
                  link: 'http://www.hergbenet.ro/autor/sorin-mihai-grad-2'
                }
              ]
            },
            {
              name: 'poezie:',
              juriu: [
                {
                  name: 'Teodor Dună',
                  pic: 'https://upload.wikimedia.org/wikipedia/commons/b/b7/Teodor_duna.jpg',
                  link: 'https://ro.wikipedia.org/wiki/Teodor_Dun%C4%83'
                },
                {
                  name: 'Dan Coman',
                  pic: 'http://blog.goethe.de/dlite/uploads/DanComan.jpg',
                  link: 'https://ro.wikipedia.org/wiki/Dan_Coman'
                },
                {
                  name: 'Elena Vlădăreanu',
                  pic: 'http://www.agentiadecarte.ro/wp-content/uploads/2016/06/elena-vladareanu-foto-filb.jpg',
                  link: 'https://ro.wikipedia.org/wiki/Elena_Vl%C4%83d%C4%83reanu'
                }
              ]
            },
            {
              name: 'artă fotografică:',
              juriu: [
                {
                  name: 'Ionuț Pițurescu',
                  pic: 'https://www.berlinale-talents.de/bt/photos/000/033/33785_normal.jpg',
                  link: 'https://ro.linkedin.com/in/ionut-piturescu-b9814465'
                },
                {
                  name: 'Tudor Botezatu',
                  pic: 'http://pustnik.com/uploads/participants/Tudor-Botezatu.jpg',
                  link: 'https://vimeo.com/93789544'
                },
                {
                  name: 'Daniel Ionescu',
                  pic: 'http://www.blecherfest.ro/pics/deni-profile.jpg',
                  link: 'https://www.linkedin.com/in/daniel-ionescu-22550329/'
                }
              ]
            }
          ]
        },
        conditions: `Pentru a participa, vă rugăm să citiți cu atenție
                    regulamentul pentru fiecare secțiune, și apoi să vă înscrieți
                    folosind formularul de mai jos.`,
        themes: {
          proza: `Timpul care nu s-a scurs încă`
        },
        rules: {
          poezie: [
            {
              name: 'Anexe proză și poezie',
              url: 'Anexa-1-si-2-Concursul-literar-Max-Blecher-2018.docx'
            },
            {
              name: 'Regulament proză și poezie',
              url: 'Regulament-oficial-Concurs-literar-Max-Blecher-2018.docx'
            }
          ],
          shortMovies: [
            {
              name: 'Anexe artă fotografică',
              url: 'Anexa-1-si-2-Concurs-arta-fotografica-Max-Blecher-2018.docx'
            },
            {
              name: 'Regulament artă fotografică',
              url: 'Regulament-oficial-Concurs-arta-fotografica-Max-Blecher-2018.docx'
            }
          ]
        },
        form: {
          name: 'Formular înscriere:',
          fields: {
            prenume: 'prenume',
            nume: 'nume',
            oras: 'oraș',
            email: 'email'
          },
          categories: {
            defaultName: 'Selectati sectiunea',
            sections: [
              'proza',
              'poezie',
              'artă fotografică'
            ]
          },
          upload: 'Atașați manuscrisul/fotografia și anexele completate (max. 2 fișiere - Anexa + Manuscris/Foto)',
          terms: `Am citit si sunt de-acord cu regulamentul concursului`,
          btn: 'TRIMITE'
        },
        uploadSuccess: `Felicitări, lucrarea ta a fost înregistrată în concurs. Îți dorim mult succes!`,
        castigatori: {
          poezie: {
            I: [`Emilia Nedelcoff, Iași`, 'Emilia'],
            II: [`Vlad Serdarian, București`, 'Vlad'],
            III: [`Andreea Petrovici, Suceava`, 'Andreea']
          },
          proză: {
            I: [`Matei Bălan, Botoșani`, 'Matei'],
            II: [`Andreea Alexandrina Lungu, Galați`, 'Andreea'],
            III: [`Cătălin Furtună, București`, 'Catalin']
          },
          'artă fotografică': {
            I: [`Ștefan Leonte, Roman`, 'Stefan'],
            II: [`Iulia Diana Roșu, Nazna, jud. Mureș`, 'Iulia'],
            III: [`Sara Pleșa Popescu, Deva`, 'Sara']
          }
        }
      },
      archive: {
        title: 'Ediții anterioare:',
        editions: ['2017']
      },
      contact: {
        title: 'Adresează-ne o întrebare:',
        form: {
          name: 'nume',
          email: 'email',
          msg: 'mesaj'
        },
        btn: 'trimite'
      },
      press: [],
      voluntar: {
        categories: [
          'Biciclist (promovează festivalul pe bicicletă în Roman sau alte orașe din apropiere)',
          'Tehnician (asistent pe echipamentele tehnice din cadrul festivalului)',
          'Heirupist (partea logistică a festivalului)',
          'Sociabil (relaționează cu invitații și participanții festivalului)'
        ]
      },
      invitati: [],
      program: {
        Vineri: [],
        Sambata: [],
        Duminica: []
      },
      echipa: [
        {
          nume: 'Irina Mihălcuț',
          rol: 'fondator',
          pic: 'irina.jpg'
        },
        {
          nume: 'Alina Donosă',
          rol: 'comunicare',
          pic: 'alina.jpg'
        },
        {
          nume: 'Andreea Olivia Farcaș',
          rol: 'logistică',
          pic: 'andreea.jpg'
        },
        {
          nume: 'Doris Mironescu',
          rol: 'coordonator literar',
          pic: 'doris.jpg'
        },
        {
          nume: 'Vasile Gherghel',
          rol: 'coordonator principal',
          pic: 'vasile.jpg'
        },
        {
          nume: 'Ciprian Fechetă',
          rol: 'logistică',
          pic: 'ciprian.jpg'
        },
        {
          nume: 'Sebastian Hrib',
          rol: 'logistică',
          pic: 'sebastian.jpg'
        },
        {
          nume: 'Emilian Pal',
          rol: 'ambasador',
          pic: 'emilian.jpg'
        }
      ],
      parteneri: {
        sponsor: [
          {
            nume: 'Primăria Municipiului Roman',
            pic: 'primariaRoman.jpg',
            url: 'http://www.primariaroman.ro/',
            type: 'sponsor'
          },
          {
            nume: 'Casa Romașcană',
            pic: 'casa_romascana.jpg',
            url: 'https://casaromascana.com/',
            type: 'sponsor'
          },
          {
            nume: 'Comunitatea Evreilor',
            pic: 'fcer.jpg',
            url: 'https://www.jewishfed.ro/',
            type: 'sponsor'
          },
          {
            nume: 'BIZZ',
            pic: 'bizzonwheels.png',
            url: 'http://www.bizzonwheels.com/',
            type: 'sponsor'
          },
          {
            nume: 'PIZZA21',
            pic: 'pizza-21.png',
            url: 'https://www.facebook.com/PIZZA-21-1299871430040030/?rf=143423106078532',
            type: 'sponsor'
          },
          {
            nume: 'Nemteana',
            pic: 'nemteana.png',
            url: 'http://www.nemteana.ro/',
            type: 'sponsor'
          },
          {
            nume: 'Farcas',
            pic: 'farcas.jpg',
            url: '#',
            type: 'sponsor'
          },
          {
            nume: 'Fereastra-1',
            pic: 'fereastra-1.jpg',
            url: 'https://fereastra1.ro/',
            type: 'sponsor'
          },
          {
            nume: 'Sense',
            pic: 'sense.jpg',
            url: 'http://fashionsense.ro/',
            type: 'sponsor'
          },
          {
            nume: 'Bacania cu Dichis',
            pic: 'bacania.jpg',
            url: 'https://web.facebook.com/BacaniaCuDichisRoman',
            type: 'sponsor'
          },
          {
            nume: 'TE-ROX',
            pic: 'te-rox.jpg',
            url: '',
            type: 'sponsor'
          }
        ],
        partener: [
          {
            nume: 'Flanders Literature',
            pic: 'flanders.jpg',
            url: 'https://www.flandersliterature.be/',
            type: 'partener'
          },
          {
            nume: 'Teatru Gong',
            pic: 'gong.jpg',
            url: 'https://www.facebook.com/Trupa-De-Teatru-Gong-466996656701035/',
            type: 'partener'
          },
          {
            nume: 'PerfectKLIK',
            pic: 'PK.png',
            url: 'https://www.perfectklik.com/ro/',
            type: 'partener'
          },
          {
            nume: 'BursaBinelui',
            pic: 'bursaBinelui.png',
            url: 'https://www.bursabinelui.ro/BursaBinelui/Proiecte/Blecher-Fest-2018',
            type: 'partener'
          },
          {
            nume: 'Biblioteca',
            pic: 'biblioteca.jpg',
            url: '#',
            type: 'partener'
          },
          {
            nume: 'Asoc Musatinii',
            pic: 'musatinii.jpg',
            url: 'https://musatinii.wordpress.com/',
            type: 'partener'
          },
          {
            nume: 'Kult',
            pic: 'kult_hub.png',
            url: 'http://www.kulthub.ro/',
            type: 'partener'
          },
          {
            nume: 'MUNAY',
            pic: 'munay.png',
            url: 'http://munaylife.ro/',
            type: 'partener'
          },
          {
            nume: 'TDL',
            pic: 'tdl.jpg',
            url: 'http://thedigitallabs.com/',
            type: 'partener'
          },
          {
            nume: 'UNYOUTH',
            pic: 'un_youth.jpg',
            url: 'https://www.facebook.com/unyouthroman/',
            type: 'partener'
          },
          {
            nume: 'AsAdv',
            pic: 'asadvertising.png',
            url: 'http://asadvertising.ro/',
            type: 'partener'
          },
          {
            nume: 'jews',
            pic: 'jews.jpg',
            url: '#',
            type: 'partener'
          }
        ],
        media: [
          {
            nume: 'Top All',
            pic: 'topall.jpg',
            url: 'http://tvtopall.ro/',
            type: 'media'
          },
          {
            nume: 'OK',
            pic: 'ok.jpg',
            url: 'http://revistaok.com/',
            type: 'media'
          },
          {
            nume: 'BOOKAHOLIC',
            pic: 'bookaholic.png',
            url: 'http://bookaholic.ro/',
            type: 'media'
          },
          {
            nume: 'ObservatorCultural',
            pic: 'observator.jpg',
            url: 'https://www.observatorcultural.ro/',
            type: 'media'
          },
          {
            nume: 'TVR',
            pic: 'tvriasi.png',
            url: 'http://iasi.tvr.ro/',
            type: 'media'
          }
        ]
      },
      bio: {
        'jan myskjin': `Jan H. Mysjkin, născut pe 16 noiembrie 1955 la Bruxelles, locuieşte din 1991 la Paris. Scrie atât în neerlandeză, cât şi în franceză. A publicat zece volume de poezie în neerlandeză, printre care Rekenkunde van de tastzin (Aritmetica atingerii, tradus în română de Baros/Mysjkin pentru Editura Exigent, 2012) sau Enz., enz… (Ş.a.m.d., ş.a.m.d…., tradus în română de Abăluţă/Mysjkin pentru Casa de Editură Max Blecher, 2017). A tradus nenumărate texte scrise de autori clasici şi contemporani, atât poeţi cât şi romancieri. În Belgia, transpunerile sale în neerlandeză au fost încununate cu „Premiul Naţional pentru Traducere Literară” (1990) şi, în Ţările de Jos, cu „Premiul dr. Elly-Jaffé” (2012). În ultimii ani, a publicat peste optzeci de poeţi şi prozatori români în diferite reviste belgiene, neerlandeze şi franceze, şi în volum, pe autori precum Max Blecher, Mihail Sebastian, Nichita Stănescu, Constantin Abăluţă, Cristian Popescu, Daniel Bănulescu şi Doina Ioanid. A alcătuit, de altfel, două antologii de poezie română din perioada 1960-2010: Engel in het raam op het oosten (Înger în fereastra dinspre răsărit, 2010) şi Voor de prijs van mijn mond (Cu preţul gurii, 2013). În colaborare cu Doina Ioanid a publicat două antologii de poezie flamandă contemporană: Lumina ultimei zile (Casa de Editură Max Blecher, 2014) şi Cu picioarele afară (Editura ARC, 2016). A mai apărut o selecţie de groteşti ale dadaistului flamand Paul van Ostaijen, Trustul patriotismului şi alte groteşti (Editura Paralela 45, 2016). Acelaşi duo a realizat trei dosare cu poezia română din Republica Moldova tradusă în franceză pentru revistele Poésie/première, Le Journal de Poésie şi L’Intranquille. Stă să apară cît de curând o antologie de poezie neerlandeză contemporană: Poetule, piaptănă-ţi părul! (Editura ARC, 2018).`,
        'Doina Ioanid': `Doina Ioanid (nume de scriitor), <br> Doina Ilie (nume civil) <br>
Scriitoare, traducătoare și jurnalistă <br>
Doina Ioanid s-a născut la 24 decembrie 1968, în Bucureşti. A absolvit Facultatea de Litere a Universităţii Bucureşti în 1995 şi cursurile de Master (Studii Culturale Franceze) la Facultatea de Limbi şi Literaturi Străine a aceleiaşi universităţi, în 1998. A publicat poeme în volumul colectiv Ferestre '98, girat de Mircea Cărtărescu, Editura Aristarc, Oneşti, 1998, (împreună cu Ioana Vlaşin, Cecilia Ştefănescu, Marius Ianuş, Angelo Mitchievici, Iulian Băicuș și Victor Nichifor). A participat la volumul experimental 40238 Tescani, Editura Image, Bucureşti, 2000 (alături de Ioana Nicolaie, Marius Ianuş, Domnica Drumea, Angelo Mitchievici, Mircea Cărtărescu, Cecilia Ştefănescu şi Florin Iaru). A debutat individual cu un volum de poeme în proză: Duduca de marţipan, Editura Univers, Bucureşti, 2000 (Premiul de debut „Prima Verba“). Au urmat alte volume de poezie: E vremea să porţi cercei, Editura Aula, Braşov, 2001 (volum nominalizat la Premiile Aspro);  Cartea burţilor şi a singurătăţii, Pontica, Constanţa, 2003; Poeme de trecere, Editura Vinea, București, 2005; Audio-book Poeme de trecere, Editura ninpress, 2009; Ritmuri de îmblînzit aricioaica, Editura Cartea Românească, București, 2010 şi Cusături, Editura Cartea Românească, București, 2014; Cele mai mici proze, Editura Nemira, Bucureș;ti, 2017. Poemele sale au fost traduse în franceză, maghiară, turcă, slovenă, bulgară, croată, germană, neerlandeză, engleză, galeză şi polonă, spaniolă. Doina Ioanid a tradus din limba franceză mai multe cărți, printre care: Marguerite Duras, Vara, la zece și jumătate seara – Editura Cartier, Chişinău, 2006; Dai Sijie, Într-o noapte fără lună – Editura Polirom, Iași, 2009; Karine Lambert, Femeile care au renunţat la bărbaţi – Editura Trei, Bucureşti, 2015. <br>
<br>
<br>

Ateliere de traducere:  <br><br>
Arcuș, 2006,  <br>
ICR Stockholm, Suedia, 2011 <br>
Ateliere de creație: Contes croisés – atelier européen de formation aux arts du récits, Pays de Thann, Franța, 2010 <br>

<br>
<br>
 
Burse de creaţie:
<br><br>
ICR Paris, 2007 <br>
PEN Anvers, 2014, <br>
FILIT, Iași, 2017 <br>
Passa Porta, Bruxelles, 2017 <br>

<br><br>

Bursă de traducere: <br>
<br>
La Collège des traducteurs de Seneffe, 2016 <br>
<br>
Participări la festivaluri: <br>
<br>
Festivalul Internaţional de Poezie „Ars Amandi“, Brașov, 2005 <br>
Maratonul de  Poezie, Sibiu, 2007 <br>
Festivalul Internaţional de Poezie , Istanbul, 2009 <br>
Festival Review of Small Literatures, Zagreb, 2010 <br>
Festivalul de Poezie de la Bistriţa, 2010 <br>
Dunya Festival, Rotterdam, 2011 <br>
Poetry International Festival, Rotterdam, 2011 <br>
Poetry Parnassus Festival, Londra, 2012 <br>
Biennale Internationale de Poésie, Liège, 2012 <br>
Festivalul Internaţional de Poezie de la Sibiu, 2012 <br>
Festivalul „Poezia e la Bistriţa“, 2012 <br>
Salon du Livre, Paris, 2013 <br>
Felix Poetry Festival, Anvers, 2013 <br>
Le Festival International de Poésie, Namur, 2013 <br>
North Wales International Poetry Festival, 2013 <br>
Transpoésie, Bruxelles, 2014 <br>
Lectures sous l'Arbre, Ardèche, Haute-Loire, 2015 <br>
Festivalul Internaţional de Poezie  „Primăvara Europeană a poeților“, Chișinău, 2015, 2016, 2017 <br>

<br><br>

Lucrări proprii traduse în alte limbi: <br><br>
A gyönyör roman múvészete/ Milionarii timpului, volum colectiv rezultat în urma unui atelier de traducere la Arcuș. Traduceri de Bogdán Lászlo, Lövetei Lázár Lászlo,  Sántha Attila, Fekete Vincze, Lászlo Noémi, Editura Arcuş, Arcuş, 2006 <br>
Çağdaș Romanya Șiiri (antologie), Özgür Yayinlari, Ankara, 2009, 112 p., traducere în limba turcă de Sheilla Iaia <br>
Revija malih književnosti (antologie), Zagreb, 2010, 96 p., traducere în limba croată de Ivana Olujić <br>
„Driesch“, nr. 4, decembrie 2010, Viena, traducere în limba germană de Ioana Orleanu <br>
„Ars“, 1-2/2010, Podgorica, Muntenegru, traducere de Ivana Olujić <br>
„Crosspoint“, noiembrie 2010, traducere în limba bulgară de Lora Nenkovska <br>
„Nagyvilág“, nr 9, septembrie 2010, Budapesta, traducere în limba maghiară de Lövetei Lázár Lászlo <br>
„Le Fram“, nr. 22, martie/2011, Liège, traducere în limba franceză de Jan H. Mysjkin <br>
„Poeziekrant“, nr 3, 2011, Gent,  traducere în neerlandeză de Jan H. Mysjkin <br>
„Asymptote“, Singapore, aprilie 2011, traducere în limba engleză de Florin Bican: <a href='http://asymptotejournal.com/article.php?cat=Poetry&id=27&curr_index=2&curPage=Poetry' target='_blank'>www.asymptotejournal.com</a> <br>
<br><br>
Poetry International festival Rotterdam: <a href='http://www.poetryinternational.org' target='_blank'>www.poetryinternational.org</a> <br>
<br><br>
Volume individuale traduse: <br><br>

Het juffertje van marsepein (Duduca de marţipan), în neerlandeză de Jan H. Mysjkin, Editura Douane, Rotterdam, 2011 <br>
La demoiselle de massepain (Duduca de marţipan), volum bilingv tradus de Jan H. Mysjkin, Éditions Atelier de l’agneau, 2013 <br>
Rythmes pour apprivoiser la hérissonne (Ritmuri de îmblînzit aricioaica), volum tradus de Jan H. Mysjkin, Éditions L’Arbre à paroles, Amay, 2013 <br>
[Ultimele două volume au apărut cu ocazia Salon du Livre de Paris, 2013] <br>
Oorbellen, buiken en eenzaamheid (E vremea să porţi cercei, Cartea burţilor şi a singurătăţii), volume traduse în neerlandeză de Jan H. Mysjkin, Editura Perdu, Amsterdam, 2013, <br>
Ritmen om de vrouwtjesegel te temmen (Ritmuri de îmblînzit aricioaica), tradus în neerlandeză de Jan H. Mysjkin,  Editura De Contrabas, Utrecht, 2014 <br>
Boucles d'oreilles, ventres et solitude (E vremea să porţi cercei, Cartea burţilor şi a singurătăţii), volume bilingve, traduse de Jan H. Mysjkin,  Éditions Cheyene, 2014 <br>
Coutures (Cusături), volum tradus de Jan H. Mysjkin, Éditions L’Arbre à paroles, Amay, 2015 <br>


<br><br>

Unul dintre poemele din Ritmuri de îmblînzit aricioaica, sub titlul The Yellow Dog, a intrat în topul celor mai frumoase poezii de dragoste, în selecţia celor de la Southbank Centre din Londra. <br>

Volumul Boucles d'oreilles, ventres et solitude (E vremea să porţi cercei, Cartea burţilor şi a singurătăţii), ediţie bilingvă, volum tradus de Jan H. Mysjkin,  Éditions Cheyene, 2014,  a fost nominalizat la Le Prix des Découvreurs 2017. <br>

Doina Ioanid a fost asistent universitar la catedra de Limbi Străine a Facultății de Litere, Universitatea „Transilvania“ Braşov, între anii 1998-2005. Apoi a devenit secretar de redacţie la Observator cultural (2005-2014). În prezent, este redactor la aceeaşi revistă. <br>`,
        'Nicoleta Popa Blanariu': `Nicoleta Popa Blanariu este conferenţiar universitar la Facultatea de Litere a Universităţii „Vasile Alecsandri” din Bacău, unde predă literatură comparată, literatură română şi alte discipline aflate în zona de interferenţă a studiilor literare cu ştiinţele comunicării şi ale limbajului, cu artele spectacolului şi antropologia culturală. În această zonă interdisciplinară se situează volumele Când gestul rupe tăcerea. Dansul şi paradigmele comunicării (Iaşi, „Fides”, 2008), Când literatura comparată pretinde că se destramă. Studii şi eseuri (vol. I: Invarianţii, un fir al Ariadnei?, vol. II: (Inter)text şi (meta)spectacol, Bucureşti, „Eikon”, 2016). Este, de asemenea, coautor al mai multor volume colective apărute la edituri din Statele Unite, Marea Britanie, Australia, Italia. A publicat articole în reviste ştiinţifice din Spania, India, Statele Unite, România şi în presa culturală (Ateneu, Vitraliu).  A  cotradus din limba franceză Dicţionarul de teatru al lui Patrice Pavis (Iaşi, „Fides”, 2012). Este membră în consiliul editorial al Southern Semiotic Review (Sydney, Australia) şi al revistei Studii şi cercetări ştiinţifice, seria filologie. 

<br><br>
<a href='https://ub-ro.academia.edu/NicoletaPopaBlanariu/CurriculumVitae' target='_blank'>CurriculumVitae</a>
<br><br>
<a href='https://ub-ro.academia.edu/NicoletaPopaBlanariu' target='_blank'>https://ub-ro.academia.edu/NicoletaPopaBlanariu</a>
<br><br>`
      }
    },
    EN: {
      menu: {
        about: 'about',
        contest: 'contest',
        archive: 'archive',
        contact: 'contact'
      }
    }
  },
  svg: {
    flags: {
      RO: `<svg width='40px' height='24px' viewBox='0 0 40 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
    <!-- Generator: Sketch 48 (47235) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <g id='ro-flag' fill-rule='nonzero'>
            <rect id='Rectangle-path' fill='#002B7F' x='0' y='0' width='40' height='24'></rect>
            <rect id='Rectangle-path' fill='#FCD116' x='13.3333333' y='0' width='26.6666667' height='24'></rect>
            <rect id='Rectangle-path' fill='#CE1126' x='26.6666667' y='0' width='13.3333333' height='24'></rect>
        </g>
    </g>
</svg>`,
      EN: `<svg width='44px' height='30px' viewBox='0 0 44 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
    <desc>Created with Sketch.</desc>
    <defs>
        <path d='M20,12 L40,12 L40,24 L20,12 Z M20,12 L20,24 L0,24 L20,12 Z M20,12 L0,12 L0,0 L20,12 Z M20,12 L20,0 L40,0 L20,12 Z' id='path-1'></path>
    </defs>
    <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
        <g id='uk-flag' transform='translate(2.000000, 3.000000)'>
            <polygon id='Shape' fill='#00247D' fill-rule='nonzero' points='0 0 0 24 40 24 40 0'></polygon>
            <path d='M0,0 L40,24 M40,0 L0,24' id='Shape' stroke='#FFFFFF' stroke-width='6' fill='#000000' fill-rule='nonzero'></path>
            <g id='Clipped'>
                <mask id='mask-2' fill='white'>
                    <use xlink:href='#path-1'></use>
                </mask>
                <g id='Shape'></g>
                <path d='M0,0 L40,24 M40,0 L0,24' id='Shape' stroke='#CF142B' stroke-width='4' fill='#000000' fill-rule='nonzero' mask='url(#mask-2)'></path>
            </g>
            <path d='M20,0 L20,24 M0,12 L40,12' id='Shape' stroke='#FFFFFF' stroke-width='10' fill='#000000' fill-rule='nonzero'></path>
            <path d='M20,0 L20,24 M0,12 L40,12' id='Shape' stroke='#CF142B' stroke-width='6' fill='#000000' fill-rule='nonzero'></path>
        </g>
    </g>
</svg>`
    }
  },
  contact: {
    form: {
      name: '',
      email: '',
      msg: ''
    },
    isSent: false
  },
  streetart: {
    isSent: false
  },
  voluntar: {
    form: {
      prenume: '',
      nume: '',
      varsta: '',
      email: '',
      dece: '',
      tel: '',
      limbi: '',
      categorie: ''
    },
    isForm: true,
    msg: {
      success: `Mulţumim pentru timpul acordat şi dorinţa de implicare în Programul de Voluntariat Blecher Fest 2018!
      Completarea acestui formular este un prim pas, urmat de o întâlnire informală dacă vei fi selectat și o serie de sesiuni de pregătire.
      *Minorii se angajează să nu consume băuturi alcoolice.`,
      error: `Mesajul nu a putut fi trimis datorită unei erori tehnice. Vă rugăm să ne contactați pentru a remedia defecțiunea. Vă mulțumim.`
    },
    sentMsg: ''
  },
  socialMedia: {
    fb: 'https://www.facebook.com/blecherfest.ro/'
  },
  program: {
    vineri: [
      {
        img: 'opening',
        location: 'Colegiul Național Roman-Vodă',
        zi: 'Vineri',
        name: 'Deschidere Blecher Fest',
        description: 'Întâlnire pe treptele Liceului Roman-Vodă',
        time: '17:00'
      },
      {
        img: 'casa-hogas',
        location: 'Muzeul "Casa Hogaș"',
        zi: 'Vineri',
        name: 'Mărturii vizuale despre M. Blecher',
        description: 'Expoziție de documente bibliofile, fotografii și lucrări de artă despre M.Blecher.',
        time: '17:30'
      },
      {
        img: 'trupa-percutie',
        location: 'Colegiul Național Roman-Vodă',
        zi: 'Vineri',
        name: 'Concert live percuție',
        description: 'Trupa de percuție Gh. Dima din Piatra Neamț',
        time: '19:00'
      }
    ],
    sambata: [
      {
        img: 'lansare-carte-1',
        location: 'Biblioteca Municipală "George Radu Melidon"',
        zi: 'Sambata',
        name: 'Lansare de carte - Doris Mironescu',
        description: `Lansarea volumelor criticului literar Doris Mironescu: „Viața lui M. Blecher, împotriva biografiei”, ediția a doua, Humanitas, 2018; M. Blecher, „Opere”, ediție critică realizată la Fundația Națională pentru Știință și Artă, 2017.
Invitați: criticii literari Nicoleta Popa Blanariu, Adrian Jicu, Adrian G. Romila`,
        time: '10:00'
      },
      {
        img: 'gps',
        location: 'Biblioteca Municipală "George Radu Melidon"',
        zi: 'Sambata',
        name: 'GPS Literar',
        description: 'Pe un traseu care pornește de la Bibllioteca Municipală Roman, și care va continua apoi pe strada Ștefan cel Mare, cu opriri în diferite locuri, actorii vor pune în scenă pagini din opera lui M. Blecher chiar în spațiile care, cu probabilitate, l-au inspirat pe scriitor. <br> Spectatorii sunt invitați să asocieze locuri cunoscute ale orașului cu viziunile filtrate prin imaginația scriitorului interbelic.',
        time: '11:30'
      },
      {
        img: 'casa-hogas',
        location: 'Muzeul Casa Hogaș',
        zi: 'Vineri',
        name: 'Mărturii vizuale despre M. Blecher',
        description: 'Expoziție de documente bibliofile, fotografii și lucrări de artă despre M.Blecher.',
        time: '14:00'
      },
      {
        img: 'meridiane',
        location: 'Sala "Nicolae Manolescu Strunga" a Primăriei Roman',
        zi: 'Sambata',
        name: 'M. Blecher pe meridianele lumii',
        description: 'Masă rotundă cu traducătorii operei lui M. Blecher: Bruno Mazzoni (Italia), Fernando Klabin (Brazilia), Joanna Kornas-Warwas (Polonia), Jan H. Mysjkin (Belgia). ',
        time: '15:00'
      },
      {
        img: 'momo-workshop',
        location: 'Kult Hub',
        zi: 'Sambata',
        name: 'Workshop de miscare cu Momo Sanno',
        description: 'http://www.momosanno.com/',
        time: '16:00'
      },
      {
        img: 'colosseum',
        location: 'Curtea Bibilotecii Municipale',
        zi: 'Sambata',
        name: 'Colosseum Quartet - Iași',
        description: 'Concert de muzică clasică',
        time: '17:00'
      },
      {
        img: 'urletul',
        location: 'Casa Romașcană',
        zi: 'Sambata',
        name: 'Performance URLETUL',
        description: 'Urletul de Allen Ginsberg cu Ionuț Caras și Vasile Gherghel',
        time: '20:00'
      },
      {
        img: 'feri',
        location: 'Casa Romașcană',
        zi: 'Sambata',
        time: '21:30',
        name: 'Égvilág Ségerczferi trio',
        description: 'concert de muzică românească, cu artistul Ferenc Ségercz și noul său trio'
      },
      {
        img: 'trei-parale',
        location: 'Casa Romașcană',
        zi: 'Sambata',
        name: 'Concert Trei Parale',
        description: 'concert de muzică veche românească',
        time: '22:30'
      }
    ],
    duminica: [
      {
        img: 'cimitir',
        location: 'Cimitirul Evreiesc',
        zi: 'Duminica',
        name: 'Memento M. Blecher',
        description: 'Prezentare a istoriei comunității evreiești din Roman; reculegere la mormântul lui M. Blecher; comemorare a marelui scriitor prin lecturi, recitări, alocuțiuni.',
        time: '10:00'
      },
      {
        img: '',
        location: 'Sala Primăriei',
        zi: 'Duminica',
        name: 'Festivitate Premiere',
        time: '13:00',
        description: 'Premierea câștigătorilor concursului de creație Max Blecher.'
      },
      {
        img: 'casa-hogas',
        location: 'Muzeul Casa Hogaș',
        zi: 'Vineri',
        name: 'Mărturii vizuale despre M. Blecher',
        description: 'Expoziție de documente bibliofile, fotografii și lucrări de artă despre M.Blecher.',
        time: '15:00'
      },
      {
        img: '',
        location: '',
        zi: 'Duminica',
        name: 'Deschidere evenimente stradale',
        description: 'Strada Ștefan cel Mare ce va fi închisă circulației automobilelor și deschisă evenimentelor artistice stradale.',
        time: '16:00'
      },
      {
        img: 'momo-workshop-CR',
        location: 'Casa Romașcană',
        zi: 'Duminica',
        name: 'Workshop de miscare cu Momo Sanno',
        description: 'http://www.momosanno.com/',
        time: '16:30'
      },
      {
        img: '',
        location: 'Str. Ștefan cel Mare (Casa Romașcană)',
        zi: 'Duminica',
        name: 'Trupa de teatru „Gong”, Roman',
        description: 'Spectacol de pantomimă',
        time: '17:45'
      },
      {
        img: 'miky',
        location: 'str. Ștefan cel Mare',
        zi: 'Sambata',
        name: 'Atelier desen stradal, Miki Moraru',
        description: '',
        time: '18:00'
      },
      {
        img: 'momo-performance',
        location: 'Casa Romașcană',
        zi: 'Duminica',
        name: 'Performance de miscare cu Momo Sanno',
        description: 'Spectacol de dans stradal',
        time: '20:00'
      },
      {
        img: 'pink',
        location: `Casa Romașcană`,
        zi: 'Duminica',
        name: `Concert Fine, It's Pink`,
        description: '',
        time: '21:00'
      }
    ]
  }
}

const getters = {
  lang: state => localStorage.getItem('bfLang'),
  content: state => state.content[localStorage.getItem('bfLang')],
  svg: state => state.svg,
  contact: state => state.contact,
  socialMedia: state => state.socialMedia,
  isContestUploadSuccess: state => state.isContestUploadSuccess,
  voluntar: state => state.voluntar,
  isModal: state => state.isModal,
  streetart: state => state.streetart,
  program: state => state.program
}

const actions = {
  stop_scroll ({state}, payload) {
    if (state.top === 0) {
      state.top = document.documentElement.scrollTop || document.body.scrollTop
    }
    setTimeout(() => {
      document.getElementById('app').style.overflow = payload ? 'hidden' : 'visible'
    }, 300)
    !payload && window.scroll(0, state.top)
  },
  submit_lucrare_concurs ({commit}, data) {
    const url = `https://www.electronlabs.ro/docs`
    axios({
      url,
      method: 'POST',
      headers: {'Content-Type': undefined},
      data
    })
      .then(resp => {
        // mesaj de succes
        commit(types.SET_CONTEST_MSG, 'success')
      })
      .catch(err => {
        console.log(err)
        // mesaj de eroare
      })
  },
  send_msg ({state}) {
    axios({
      url: 'static/sendMsg.php',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: state.contact.form
    })
      .then(resp => {
        resp.status === 200 &&
        Vue.set(state.contact, 'isSent', true)
        Object.keys(state.contact.form)
          .forEach(val => {
            Vue.set(state.contact.form, val, '')
          })
      })
  },
  submit_voluntar ({commit}) {
    axios({
      url: 'https://www.electronlabs.ro/voluntar',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: state.voluntar.form
    })
      .then(resp => {
        commit(types.SET_VOLUNTAR_FORM_STATE, 'success')
      })
      .catch(err => {
        commit(types.SET_VOLUNTAR_FORM_STATE, 'error')
        console.log(err.response)
      })
  },
  submit_streetart ({commit}, payload) {
    axios({
      url: 'static/sendStreetArt.php',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: payload
    })
      .then(resp => {
        resp.status === 200 &&
        Vue.set(state.streetart, 'isSent', true)
      })
      .catch(e => {
        console.log(e)
      })
  },
  get_press ({commit}) {
    axios('https://www.electronlabs.ro/press')
      .then(resp => {
        commit(types.SET_CONTENT, {
          section: 'press',
          data: resp.data.rows
        })
      })
      .catch(err => {
        console.log(err.response)
      })
  },
  get_invitati ({commit}) {
    axios('https://www.electronlabs.ro/invitati')
      .then(resp => {
        let invitati = _.sortBy(resp.data.rows, 'value.numar_ordine')
        commit(types.SET_CONTENT, {section: 'invitati', data: invitati})
      })
      .catch(err => {
        console.log(err.response)
      })
  },
  get_program ({commit}) {
    axios('https://www.electronlabs.ro/program')
      .then(resp => {
        commit(types.SET_PROGRAM, resp.data.rows)
      })
      .catch(err => {
        console.log(err.response)
      })
  },
  FB_Parse () {
    setTimeout(() => {
      window.FB.XFBML.parse()
    }, 10)
  }
}

const mutations = {
  [types.SET_CONTEST_MSG] (state, msg) {
    state.isContestUploadSuccess = msg === 'success'
  },
  [types.SET_VOLUNTAR_FORM_STATE] (state, msg) {
    Vue.set(state.voluntar, 'isForm', false)
    Vue.set(state.voluntar, 'sentMsg', state.voluntar.msg[msg])
  },
  [types.SET_CONTENT] (state, {section, data}) {
    Vue.set(state.content[localStorage.getItem('bfLang')], section, data)
  },
  [types.SET_PROGRAM] (state, data) {
    data.forEach(obj => {
      delete obj.value._id
      delete obj.value._rev
      Vue.set(state.content[localStorage.getItem('bfLang')].program, obj.id, obj.value)
    })
  },
  [types.SET_MODAL] (state) {
    state.isModal = !state.isModal
  }
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
configureModerator(store, router)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js